import { render } from "./HomeBroadcastPlay.vue?vue&type=template&id=e4d08de0"
import script from "./HomeBroadcastPlay.vue?vue&type=script&lang=ts"
export * from "./HomeBroadcastPlay.vue?vue&type=script&lang=ts"

import "./HomeBroadcastPlay.vue?vue&type=style&index=0&id=e4d08de0&lang=postcss"
script.render = render

export default script